import '@/style/common-base.less';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'amfe-flexible/index.js';
import Vant, {
    Lazyload
} from 'vant';
import 'vant/lib/index.less';
import VueWechatTitle from 'vue-wechat-title';
import _ from 'lodash';
import hdk from '@/lib/hdk.js';
import setter from '@/lib/setter.js';
import '@/style/icon/iconfont.css';
import '@/style/icon/iconfont.js';

Vue.config.productionTip = false;

Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(VueWechatTitle);
Vue.prototype.$hdk = hdk;
Vue.prototype.$setter = setter;
Vue.prototype._ = _;


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')